import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';

import { CensusEnrollmentModule } from 'store/modules/census/enrollment-based/censusEnrollmentModule';
import ElectionsModule from 'store/modules/elections/electionsModule';
import ICensusUploadPageStore from 'store/modules/census/iCensusUploadPageStore';

interface DomainProps {
  groupId: string;
  enrollmentPeriodId: string;
}
/** @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page. */
export default class CensusEnrollmentPageStore extends ICensusUploadPageStore<DomainProps, CensusEnrollmentModule> {
  private _electionsModule: ElectionsModule;
  protected _censusModule: CensusEnrollmentModule;
  protected _domainData: DomainProps;

  public get electionsModule(): ElectionsModule {
    return this._electionsModule;
  }

  public async getCensusData(): Promise<void> {
    this.setIsLoading(true);
    await Promise.all([
      this._censusModule.getRateSegmentData(),
      this._electionsModule.getStatistics(),
      this._censusModule.getPreviouslyUploadedFiles(),
      this._censusModule.uploadExistingCensus(),
    ]);
    runInAction(() => {
      this.setIsLoading(false);
    });
  }

  public onCompleteRedirect(): void {
    bpHistory.push(`/census-review/${this._domainData.groupId}/${this._domainData.enrollmentPeriodId}`);
  }

  constructor(domainData: DomainProps) {
    super();
    this._censusModule = new CensusEnrollmentModule({
      groupId: domainData.groupId,
      enrollmentPeriodId: domainData.enrollmentPeriodId,
    });
    this._electionsModule = new ElectionsModule({
      groupId: domainData.groupId,
      enrollmentPeriodId: domainData.enrollmentPeriodId,
    });
    this._domainData = domainData;

    makeObservable<CensusEnrollmentPageStore, '_censusModule' | '_electionsModule' | '_domainData'>(this, {
      _censusModule: observable,
      _electionsModule: observable,
      _domainData: observable,

      electionsModule: computed,

      getCensusData: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

/** @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page. */
const CensusEnrollmentPageStoreContext = createContext(new CensusEnrollmentPageStore({} as DomainProps));

/** @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page. */
export const useCensusEnrollmentPageStore = (): CensusEnrollmentPageStore => {
  return useContext(CensusEnrollmentPageStoreContext);
};

export { CensusEnrollmentPageStoreContext };
